
import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'
import DialogTemplate from '@/_components/dialog/template/template.vue'
import { patchUser } from '@/utils/user'

@Component({
    inheritAttrs: false,
    name: 'SetCard',
    components: { DialogTemplate },
})
export default class SetCard extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any
    cardId = ''
    loading = false
    cardExistsOnOtherUser = false
    beError = false as boolean | string

    get hasError() {
        return this.cardExistsOnOtherUser || !!this.beError
    }

    get user() {
        return this.props.user
    }

    async setCard() {
        if (!this.user) return

        try {
            this.loading = true
            const payload = {
                id: this.user.id,
                cardId: this.cardId.trim() ? this.cardId : null,
            }
            const newUser = await patchUser(this.user.id, payload)
            this.$emit('close', newUser)
        } catch (error) {
            error.data.response.data.errors.map((err) => {
                if (err.code && err.code == 'cardExistsOnOtherUser') {
                    this.cardExistsOnOtherUser = true
                    this.$store.commit('closeSnackbar')
                } else {
                    this.beError = err.detail
                }
            })
        } finally {
            this.loading = false
        }
    }

    onCardIdChange() {
        this.cardExistsOnOtherUser = false
        this.beError = false
    }

    mounted() {
        this.cardId = this.user.cardId
    }
}
